import PageContainer from '../common/page/PageContainer';
import ConnectWalletButton from './ConnectWalletButton';

const ConnectWalletPage = () => (
  <PageContainer>
    <ConnectWalletButton />
  </PageContainer>
);
export default ConnectWalletPage;
